import { ReactNode } from "react";
import Styles from "./card.module.scss";

type CardProps = {
  hero: string;
  children: ReactNode;
  className?: string;
  href?: string;
};

export const Card = ({ hero, children, className, href }: CardProps) => {
  const Container = href ? 'a' : 'div';

  return (
    <Container target="_blank" className={`${className} ${Styles.card}`} href={href}>
      <div className={Styles.hero}
        style={{ backgroundImage: `url(${hero})` }}
      >
      </div>
      <div className={Styles.content}>
        {children}
      </div>
    </Container>
  );
};
